import { useEffect, useState } from "react";
import { invoke } from "@tauri-apps/api/core";

export interface FileEntry {
  name: string;
  path: string;
  isDir: boolean;
}

interface RawEntry {
  name: string;
  path: string;
  is_dir: boolean;
}

export function useDirectory(root: string, path: string) {
  const [entries, setEntries] = useState<FileEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let disposed = false;
    setLoading(true);
    setError(null);
    invoke<RawEntry[]>("list_dir", { root, path })
      .then((raw) => {
        if (disposed) return;
        setEntries(raw.map((e) => ({ name: e.name, path: e.path, isDir: e.is_dir })));
      })
      .catch((e) => {
        if (!disposed) setError(String(e));
      })
      .finally(() => {
        if (!disposed) setLoading(false);
      });
    return () => {
      disposed = true;
    };
  }, [root, path]);

  return { entries, loading, error };
}

export function useFileContent(path: string | null) {
  const [content, setContent] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!path) {
      setContent(null);
      return;
    }
    let disposed = false;
    setLoading(true);
    setError(null);
    invoke<string>("read_text_file", { path })
      .then((text) => {
        if (!disposed) setContent(text);
      })
      .catch((e) => {
        if (!disposed) setError(String(e));
      })
      .finally(() => {
        if (!disposed) setLoading(false);
      });
    return () => {
      disposed = true;
    };
  }, [path]);

  return { content, loading, error };
}
